export interface SpartaEmployeeLabor {
  employeeLaborID: string;
  dateWorked?: Date;
  hours?: number;
  earnCode?: string;
  phase?: string;
}
